module.exports = __webpack_public_path__ + "static/media/student-cert.54ea42b4.jpg";